/**
 * Pre-compiled fr-FR messages for DataTable
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  comfortable: `Confortable`,
  comfortableAriaLabel: `Section Confortable`,
  compact: `Compact`,
  compactAriaLabel: `Section Compact`,
  dataTable: `Tableau de données`,
  dataTableBody: `Corps du tableau de données`,
  dataTableHeader: `En-tête du tableau de données`,
  expandRows: `Agrandir les lignes`,
  fullText: `Texte complet`,
  fullTextAriaLabel: `Section Texte complet`,
  hiddenColumns: `Colonnes masquées`,
  hiddenColumnsAriaLabel: `Liste des colonnes masquées`,
  hideColumn: `Masquer la colonne`,
  layoutSettings: `Paramètres de disposition`,
  layoutSettingsAriaLabel: `Section Paramètres de disposition`,
  noHiddenColumns: `Pas de colonnes masquées`,
  pinRows: `Épingler les lignes`,
  reset: `Réinitialiser les colonnes`,
  resizeColumn: `Modifier la taille de la colonne`,
  rowDensity: `Densité des lignes`,
  rowDensityAriaLabel: `Section Densité des lignes`,
  searchHiddenColumns: `Rechercher...`,
  selectRow: `Sélectionner une ligne`,
  settings: `Paramètres du tableau`,
  settingsTabsAriaLabel: `Onglets « Paramètres »`,
  textPreviews: `Aperçu du texte`,
  textPreviewsAriaLabel: `Section Aperçu du texte`,
  textVisibility: `Visibilité du texte`,
  textVisibilityAriaLabel: `Section Visibilité du texte`,
  visibleColumns: `Colonnes visibles`,
  visibleColumnsAria: `Liste des colonnes visibles`,
  visibleColumnsList: `Colonnes visibles`,
};
